export const templateTabs = [
  {
    label: "应用",
    value: "SheetList"
  },
  {
    label: "管理",
    value: "Setting"
  }
]

export const themeStyleMap = {
  standard: {
    background: "#edeff1",
    search: "search",
    submenu: "standard-submenu"
  },
  simple: {
    background: "#fff",
    search: "",
    submenu: "simple-submenu"
  }
}
